export const ADDRESS_TYPE = {
  HOME_ADDRESS: 'HOME_ADDRESS',
  BILLING_ADDRESS: 'BILLING_ADDRESS',
  CORRESPONDENCE_ADDRESS: 'CORRESPONDENCE_ADDRESS',
};
